<template>
  <footer class="footer">
    <div class="content is-clearfix">
      <p class="sub-title is-pulled-left">© {{ currentYear }} ShareDocView</p>
      <p class="is-pulled-right">
        <a
          class="has-text-light"
          href="https://sharedocview.com/feedback.html"
          target="_blank"
        >
          Feedback
        </a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style lang="scss" scoped></style>
